import Default from "layout/Default";
import ProductOverview from "pages/ProductOverview";
import Products from "pages/Products";

const routes = () => {
  const routesWithLanguages = [
    {
      element: <Default />,
      path: `/lipbalm`,
      children: [
        { path: `/lipbalm/`, element: <ProductOverview /> },
        { path: `/lipbalm/show-case`, element: <Products /> },
      ],
    },
  ];

  return routesWithLanguages;
};

export default routes;
